import React from "react";

interface ShareProps {
    title: string;
    text: string;
    url: string
}

export const Share: React.FC<ShareProps> = ({ title, text, url }) => {
    const shareContent = async () => {
        const shareData = {
            title,
            text,
            url
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (error) {
                console.error('Ошибка при попытке поделиться:', error);
            }
        } else {
            try {
                await navigator.clipboard.writeText(shareData.url);
            } catch (error) {
                console.error('Не удалось скопировать ссылку:', error);
            }
        }
    };

    return (
        <div className="cursor-pointer" onClick={ shareContent }>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M17.0356 8.9034C16.643 8.91132 16.2528 8.84083 15.8878 8.69606C15.5228 8.5513 15.1903 8.33516 14.9099 8.06032C14.6294 7.78547 14.4066 7.45743 14.2545 7.09541C14.1024 6.7334 14.0241 6.34467 14.0241 5.952C14.0241 5.55933 14.1024 5.1706 14.2545 4.80859C14.4066 4.44657 14.6294 4.11853 14.9099 3.84368C15.1903 3.56884 15.5228 3.3527 15.8878 3.20794C16.2528 3.06317 16.643 2.99268 17.0356 3.0006C17.8185 3.0006 18.5694 3.31161 19.123 3.86522C19.6766 4.41883 19.9876 5.16968 19.9876 5.9526C19.9876 6.73552 19.6766 7.48637 19.123 8.03998C18.5694 8.59359 17.8185 8.9046 17.0356 8.9046V8.9034ZM17.0356 21.0018C16.643 21.0097 16.2528 20.9392 15.8878 20.7945C15.5228 20.6497 15.1903 20.4336 14.9099 20.1587C14.6294 19.8839 14.4066 19.5558 14.2545 19.1938C14.1024 18.8318 14.0241 18.4431 14.0241 18.0504C14.0241 17.6577 14.1024 17.269 14.2545 16.907C14.4066 16.545 14.6294 16.2169 14.9099 15.9421C15.1903 15.6672 15.5228 15.4511 15.8878 15.3063C16.2528 15.1616 16.643 15.0911 17.0356 15.099C17.8081 15.1146 18.5436 15.4324 19.0844 15.9842C19.6252 16.536 19.9281 17.2778 19.9281 18.0504C19.9281 18.823 19.6252 19.5648 19.0844 20.1166C18.5436 20.6684 17.8081 20.9862 17.0356 21.0018V21.0018ZM6.952 14.9538C6.16908 14.9538 5.41823 14.6428 4.86462 14.0892C4.31101 13.5356 4 12.7847 4 12.0018C4 11.2189 4.31101 10.468 4.86462 9.91442C5.41823 9.36081 6.16908 9.0498 6.952 9.0498C7.73492 9.0498 8.48577 9.36081 9.03938 9.91442C9.59299 10.468 9.904 11.2189 9.904 12.0018C9.904 12.7847 9.59299 13.5356 9.03938 14.0892C8.48577 14.6428 7.73492 14.9538 6.952 14.9538V14.9538Z"
                    stroke="#949494" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.3656 8L10 10.5224M14.3656 16.5704L10 14.0504" stroke="#949494" strokeWidth="1.5"
                      strokeLinecap="round"/>
            </svg>
        </div>
    )
}